import React, { Component } from "react";
import { Collapse, Menu, Dropdown, notification, Icon } from "antd";
import { Link } from "react-router-dom";
import { GlobalContext } from "../../../../app/providers/GlobalState";
import axios from "axios";
import moment from "moment";
import screenfull from "screenfull";
import {
    iconVideo,
    iconAudio,
    iconHtml,
    iconPdf,
    iconQuestionario,
    iconAvaliacao,
    iconDownload,
    iconTrabalhoIndividual,
    iconTrabalhoGrupo,
    iconTrabalhoColaborativo,
    iconLink,
    iconSumario,
    iconSessaoPresencial,
    iconPasta,
    iconQuestionarioProgresso,
    iconQuestionarioDirigido,
    iconPresencas
} from "../../../../assets/tipoDeConteudos";

const Panel = Collapse.Panel;
const openNotificationWithIcon = (type, message, description) => {
    notification[type]({
        message: message,
        description: description
    });
};

class Modulo extends Component {
    static contextType = GlobalContext;
    constructor(props) {
        super(props);
        this.state = {
            moduloid: 0,
            tituloModulo: "",
            ordemModulo: "",
            drawerModuloVisible: false,
            precedencia_nome: "",
            precedencia_concluida: false,
            //COLLAPSE
            aberto: false,
            collapsed: ["0"],
            //PERMISSOES
            curso_iniciado: false,
            //INSCRICAO
            inscrito: false,
            //FULLSCREEN
            fullscreen: false
        };

        this.elementFullScreen = React.createRef();
    }

    UNSAFE_componentWillMount() {
        axios.defaults.timeout = 60 * 10 * 1000;
    }

    //CHAMADA ANTES DO RENDER
    componentDidMount() {
        //this.carregaPrecedencia();

        if (this.props.index === this.props.modulo_aberto)
            this.setState({
                aberto: true
            });
    }

    //FORMATA AS HORAS EM STRING 00H00
    formatarHoras = hora => {
        var horas = moment(hora, "HH:mm");
        if (moment.duration(hora, "minutes").asMinutes() > 59) return horas.format("HH").slice(0, 2) + "h" + horas.format("mm").slice(0, 2);
        else return horas.format("m").slice(0, 2) + "m";
    };

    calcular = aula => {
        var total = 0;

        if (aula.dt_inicio && aula.hora) {
            let d1 = moment(aula.hora, "HH:mm:ss");
            let d2 = moment(aula.dt_inicio);

            d2 = d2.set({
                hour: d1.get("hour"),
                minute: d1.get("minute"),
                second: d1.get("second")
            });

            total = d2.diff(moment(), "hours");
        } else if (aula.dt_inicio) total = moment(aula.dt_inicio).diff(moment(), "hours");
        else if (aula.hora) {
            let d1 = moment(aula.hora, "HH:mm:ss");
            let d2 = moment();

            d2 = d2.set({
                hour: d1.get("hour"),
                minute: d1.get("minute"),
                second: d1.get("second")
            });

            total = d2.diff(moment(), "hours");
        }

        return total;
    };

    notificar = (aula, tipo) => {
        if (aula.dt_inicio && aula.hora) {
            let d1 = moment(aula.hora, "HH:mm:ss");
            let d2 = moment(aula.dt_inicio);

            d2 = d2.set({
                hour: d1.get("hour"),
                minute: d1.get("minute"),
                second: d1.get("second")
            });

            openNotificationWithIcon("warning", "Atenção", tipo + " disponível a " + d2.format("DD/MM/YYYY") + " às " + d2.format("HH:mm"));
        } else if (aula.dt_inicio)
            openNotificationWithIcon("warning", "Atenção", tipo + " disponível a " + moment(aula.dt_inicio).format("DD/MM/YYYY"));
        else if (aula.hora) {
            let d1 = moment(aula.hora, "HH:mm:ss");
            let d2 = moment();

            d2 = d2.set({
                hour: d1.get("hour"),
                minute: d1.get("minute"),
                second: d1.get("second")
            });

            openNotificationWithIcon("warning", "Atenção", tipo + " disponível a " + d2.format("DD/MM/YYYY") + " às " + d2.format("HH:mm"));
        }
    };

    onClink = aulaId => {
        localStorage.setItem("modulo_aberto", this.props.index);
        localStorage.setItem("codigo_aula", aulaId);
    };

    onClinkConcluido = (moduloId, aulaId) => {
        localStorage.setItem("modulo_aberto", this.props.index);
        this.props.concluirAula(moduloId, aulaId);
    };

    onClinkValidar = (aula, disponivel, tipo, aulaId) => {
        localStorage.setItem("modulo_aberto", this.props.index);
        localStorage.setItem("codigo_aula", aulaId);

        if (!disponivel) {
            this.notificar(aula, tipo);
        }
    };

    onChangeCollapse = collapsed => {
        this.setState({
            collapsed
        });
    };

    onClickFullscreenElement = () => {
        screenfull.toggle(this.elementFullScreen.current);
        this.setState({ fullscreen: !this.state.fullscreen });
    };

    render() {
        //MONTA O TITULO E LOGICA NO MODULO
        const tituloModulo = (
            <div>
                <div className="modulo-header">
                    <div className="modulo-container-esquerda">
                        <span className="modulo-num">{this.props.modulo.nome}</span>
                        {this.props.modulo.precedencia && (
                            <span className="modulo-precedencia" title={this.props.modulo.precedencia}>
                                <Icon type="api" className={this.props.modulo.obrigatoria ? "obrigatoria" : ""} />
                            </span>
                        )}
                    </div>
                </div>
                {this.props.modulo.objetivos && (
                    <div className="modulo-header-objetivos">
                        <span>{this.props.modulo.objetivos}</span>
                    </div>
                )}
            </div>
        );

        //MONTA A RESPETIVA AULA
        const montaAula = (moduloId, aula, estado) => {
            var tipoId = aula.tipo_Recurso.id;

            if (
                ((this.props.inscrito && estado) || (!estado && tipoId !== 5 && tipoId !== 6 && tipoId !== 8)) &&
                (!this.props.modulo.precedencia ||
                    (this.props.modulo.precedencia && !this.props.modulo.obrigatoria) ||
                    (this.props.modulo.precedencia &&
                        this.props.modulo.obrigatoria &&
                        localStorage.getItem("estado_atividade_" + this.props.modulo.precendenciaId) === "true"))
            ) {
                var inicioUrl = `/${this.props.entidade}/curso/${this.props.curso
                    .replace(/[&/\\#,+()$~%.'":*?!<>{}\s]/g, "-")
                    .toLowerCase()}/${this.props.cursoid}/tarefa/${aula.nome.replace(/[&/\\#,+()$~%.'":*?!<>{}\s]/g, "-").toLowerCase()}`;

                if (tipoId === 1) {
                    //VIDEO
                    return (
                        <Link
                            to={`${inicioUrl}${aula.tipo_Recurso.url}${
                                aula.modulo_Aulas_Utilizadores
                                    ? aula.modulo_Aulas_Utilizadores.periodo_onde_esta !== null
                                        ? "?start=" + aula.modulo_Aulas_Utilizadores.periodo_onde_esta
                                        : ""
                                    : ""
                            }`}
                            onClick={() => this.onClink(aula.id)}
                        >
                            <span className="start" title={aula.tipo_Recurso.nome} style={{ width: 30, height: 30 }}>
                                <img src={iconVideo} style={{ width: "100%", objectFit: "contain", borderRadius: "50%" }} />
                            </span>
                            <span className="licao">
                                {aula.nome}
                                {aula.modulo_Aulas_Utilizadores && aula.modulo_Aulas_Utilizadores.marcador && (
                                    <span className="marcador" style={{ marginLeft: "10px" }}>
                                        <i className="fas fa-bookmark" />
                                    </span>
                                )}
                            </span>
                        </Link>
                    );
                } //VIDEO
                else if (tipoId === 2) {
                    //AUDIO
                    return (
                        <Link
                            to={`${inicioUrl}${aula.tipo_Recurso.url}${
                                aula.modulo_Aulas_Utilizadores
                                    ? aula.modulo_Aulas_Utilizadores.periodo_onde_esta !== null
                                        ? "?start=" + aula.modulo_Aulas_Utilizadores.periodo_onde_esta
                                        : ""
                                    : ""
                            }`}
                            onClick={() => this.onClink(aula.id)}
                        >
                            <span className="start" title={aula.tipo_Recurso.nome} style={{ width: 30, height: 30 }}>
                                <img src={iconAudio} style={{ width: "100%", objectFit: "contain", borderRadius: "50%" }} />
                            </span>
                            <span className="licao">
                                {aula.nome}
                                {aula.modulo_Aulas_Utilizadores && aula.modulo_Aulas_Utilizadores.marcador && (
                                    <span className="marcador" style={{ marginLeft: "10px" }}>
                                        <i className="fas fa-bookmark" />
                                    </span>
                                )}
                            </span>
                        </Link>
                    );
                } //AUDIO
                else if (tipoId === 3 || tipoId === 12) {
                    //HTML
                    return (
                        <Link
                            to={`${inicioUrl}${aula.tipo_Recurso.url}`}
                            onClick={() => this.onClink(aula.id)}
                            //disabled={this.validarDisponibilidade()}
                        >
                            <span className="start" title={aula.tipo_Recurso.nome} style={{ width: 30, height: 30 }}>
                                <img src={iconHtml} style={{ width: "100%", objectFit: "contain", borderRadius: "50%" }} />
                            </span>
                            <span className="licao">
                                {aula.nome}
                                {aula.modulo_Aulas_Utilizadores && aula.modulo_Aulas_Utilizadores.marcador && (
                                    <span className="marcador" style={{ marginLeft: "10px" }}>
                                        <i className="fas fa-bookmark" />
                                    </span>
                                )}
                            </span>
                        </Link>
                    );
                } //HTML
                else if (tipoId === 4) {
                    //PDF
                    return (
                        <Link
                            to={`${inicioUrl}${aula.tipo_Recurso.url}`}
                            onClick={() => this.onClink(aula.id)}
                            //disabled={this.validarDisponibilidade()}
                        >
                            <span className="start" title={aula.tipo_Recurso.nome} style={{ width: 30, height: 30 }}>
                                <img src={iconPdf} style={{ width: "100%", objectFit: "contain", borderRadius: "50%" }} />
                            </span>
                            <span className="licao">
                                {aula.nome}
                                {aula.modulo_Aulas_Utilizadores && aula.modulo_Aulas_Utilizadores.marcador && (
                                    <span className="marcador" style={{ marginLeft: "10px" }}>
                                        <i className="fas fa-bookmark" />
                                    </span>
                                )}
                            </span>
                        </Link>
                    );
                } //PDF
                else if (tipoId === 7) {
                    //DOWNLOAD
                    return (
                        <Link to={`${inicioUrl}${aula.tipo_Recurso.url}`} onClick={() => this.onClink(aula.id)}>
                            <span className="start" title={aula.tipo_Recurso.nome} style={{ width: 30, height: 30 }}>
                                <img src={iconDownload} style={{ width: "100%", objectFit: "contain", borderRadius: "50%" }} />
                            </span>
                            <span className="licao">
                                {aula.nome}
                                {aula.modulo_Aulas_Utilizadores && aula.modulo_Aulas_Utilizadores.marcador && (
                                    <span className="marcador" style={{ marginLeft: "10px" }}>
                                        <i className="fas fa-bookmark" />
                                    </span>
                                )}
                            </span>
                        </Link>
                    );
                } //DOWNLOAD
                else if (tipoId === 9) {
                    //LINK
                    return (
                        <Link
                            to={`${inicioUrl}${aula.tipo_Recurso.url}`}
                            onClick={() => this.onClink(aula.id)}
                            //disabled={this.validarDisponibilidade()}
                        >
                            <span className="start" title={aula.tipo_Recurso.nome} style={{ width: 30, height: 30 }}>
                                <img src={iconLink} style={{ width: "100%", objectFit: "contain", borderRadius: "50%" }} />
                            </span>
                            <span className="licao">
                                {aula.nome}
                                {aula.modulo_Aulas_Utilizadores && aula.modulo_Aulas_Utilizadores.marcador && (
                                    <span className="marcador" style={{ marginLeft: "10px" }}>
                                        <i className="fas fa-bookmark" />
                                    </span>
                                )}
                            </span>
                        </Link>
                    );
                } //LINK
                else if (tipoId === 10) {
                    //SUMÁRIO
                    return (
                        <Link
                            to={`${inicioUrl}${aula.tipo_Recurso.url}`}
                            onClick={() => this.onClink(aula.id)}
                            //disabled={this.validarDisponibilidade()}
                        >
                            <span className="start" title={aula.tipo_Recurso.nome} style={{ width: 30, height: 30 }}>
                                <img src={iconSumario} style={{ width: "100%", objectFit: "contain", borderRadius: "50%" }} />
                            </span>
                            <span className="licao">
                                {aula.nome}
                                {aula.modulo_Aulas_Utilizadores && aula.modulo_Aulas_Utilizadores.marcador && (
                                    <span className="marcador" style={{ marginLeft: "10px" }}>
                                        <i className="fas fa-bookmark" />
                                    </span>
                                )}
                                {aula.dt_inicio && (
                                    <span className="data-hora">
                                        <strong>
                                            {moment(aula.dt_inicio).format("DD/MM/YYYY")}
                                            {aula.hora && <> - {aula.hora}</>}
                                        </strong>
                                    </span>
                                )}
                            </span>
                        </Link>
                    );
                } //SUMÁRIO
                else if (tipoId === 11) {
                    //PRESENCIAL
                    return (
                        <Link
                            to={`${inicioUrl}${aula.tipo_Recurso.url}`}
                            onClick={() => this.onClink(aula.id)}
                            //disabled={this.validarDisponibilidade()}
                        >
                            <span className="start" title={aula.tipo_Recurso.nome} style={{ width: 30, height: 30 }}>
                                <img src={iconSessaoPresencial} style={{ width: "100%", objectFit: "contain", borderRadius: "50%" }} />
                            </span>
                            <span className="licao">
                                {aula.nome}
                                {aula.modulo_Aulas_Utilizadores && aula.modulo_Aulas_Utilizadores.marcador && (
                                    <span className="marcador" style={{ marginLeft: "10px" }}>
                                        <i className="fas fa-bookmark" />
                                    </span>
                                )}
                                {aula.dt_inicio && (
                                    <span className="data-hora">
                                        <strong>
                                            {moment(aula.dt_inicio).format("DD/MM/YYYY")}
                                            {aula.hora && <> - {aula.hora}</>}
                                        </strong>
                                    </span>
                                )}
                            </span>
                        </Link>
                    );
                } //PRESENCIAL
                else {
                    //PASTA
                    return (
                        <Link
                            to="#"
                            className="tarefa-sem-link"
                            //disabled={this.validarDisponibilidade()}
                        >
                            <span className="start" title={aula.tipo_Recurso.nome} style={{ width: 30, height: 30 }}>
                                <img src={iconPasta} style={{ width: "100%", objectFit: "contain", borderRadius: "50%" }} />
                            </span>
                            <span className="licao">{aula.nome}</span>
                        </Link>
                    );
                } //PASTA
            } else {
                var icon = "";

                if (tipoId === 1) icon = <img src={iconVideo} style={{ width: "100%", objectFit: "contain", borderRadius: "50%" }} />;
                else if (tipoId === 2) icon = <img src={iconAudio} style={{ width: "100%", objectFit: "contain", borderRadius: "50%" }} />;
                else if (tipoId === 3) icon = <img src={iconHtml} style={{ width: "100%", objectFit: "contain", borderRadius: "50%" }} />;
                else if (tipoId === 4) icon = <img src={iconPdf} style={{ width: "100%", objectFit: "contain", borderRadius: "50%" }} />;
                else if (tipoId === 7)
                    icon = <img src={iconDownload} style={{ width: "100%", objectFit: "contain", borderRadius: "50%" }} />;
                else if (tipoId === 9) icon = <img src={iconLink} style={{ width: "100%", objectFit: "contain", borderRadius: "50%" }} />;
                else if (tipoId === 10)
                    icon = <img src={iconSumario} style={{ width: "100%", objectFit: "contain", borderRadius: "50%" }} />;
                else if (tipoId === 11)
                    icon = <img src={iconSessaoPresencial} style={{ width: "100%", objectFit: "contain", borderRadius: "50%" }} />;
                else icon = <img src={iconPasta} style={{ width: "100%", objectFit: "contain", borderRadius: "50%" }} />;

                return (
                    <Link to="#" style={{ cursor: "default" }}>
                        <span className="start" title={aula.tipo_Recurso.nome} style={{ width: 30, height: 30 }}>
                            {icon}
                        </span>
                        <span className="licao">{aula.nome}</span>
                    </Link>
                );
            }
        };

        //MONTA A RESPETIVA AULA DE LVL 2
        const montaAulaLvl2 = (moduloId, aula, index, estado) => {
            var tipoId = aula.tipo_Recurso.id;

            if (
                ((this.props.inscrito && estado) || (!estado && tipoId !== 5 && tipoId !== 6 && tipoId !== 8 && tipoId !== 14)) &&
                (!this.props.modulo.precedencia ||
                    (this.props.modulo.precedencia && !this.props.modulo.obrigatoria) ||
                    (this.props.modulo.precedencia &&
                        this.props.modulo.obrigatoria &&
                        localStorage.getItem("estado_atividade_" + this.props.modulo.precendenciaId) === "true"))
            ) {
                var inicioUrl = `/${this.props.entidade}/curso/${this.props.curso
                    .replace(/[&/\\#,+()$~%.'":*?!<>{}\s]/g, "-")
                    .toLowerCase()}/tarefa/${aula.nome.replace(/[&/\\#,+()$~%.'":*?!<>{}\s]/g, "-").toLowerCase()}`;

                if (tipoId === 1) {
                    //VIDEO
                    return (
                        <Link
                            to={`${inicioUrl}${aula.tipo_Recurso.url}${
                                aula.modulo_Aulas_Utilizadores
                                    ? aula.modulo_Aulas_Utilizadores.periodo_onde_esta !== null
                                        ? "?start=" + aula.modulo_Aulas_Utilizadores.periodo_onde_esta
                                        : ""
                                    : ""
                            }`}
                            onClick={() => this.onClink(aula.id)}
                            //disabled={this.validarDisponibilidade()}
                        >
                            <span className="start" title={aula.tipo_Recurso.nome} style={{ width: 30, height: 30 }}>
                                <img src={iconVideo} style={{ width: "100%", objectFit: "contain", borderRadius: "50%" }} />
                            </span>
                            <span className="licao">
                                {aula.nome}
                                {aula.modulo_Aulas_Utilizadores && aula.modulo_Aulas_Utilizadores.marcador && (
                                    <span className="marcador" style={{ marginLeft: "10px" }}>
                                        <i className="fas fa-bookmark" />
                                    </span>
                                )}
                            </span>
                        </Link>
                    );
                } //VIDEO
                else if (tipoId === 2) {
                    //AUDIO
                    return (
                        <Link
                            to={`${inicioUrl}${aula.tipo_Recurso.url}${
                                aula.modulo_Aulas_Utilizadores
                                    ? aula.modulo_Aulas_Utilizadores.periodo_onde_esta != null
                                        ? "?start=" + aula.modulo_Aulas_Utilizadores.periodo_onde_esta
                                        : ""
                                    : ""
                            }`}
                            onClick={() => this.onClink(aula.id)}
                        >
                            <span className="start" title={aula.tipo_Recurso.nome} style={{ width: 30, height: 30 }}>
                                <img src={iconAudio} style={{ width: "100%", objectFit: "contain", borderRadius: "50%" }} />
                            </span>
                            <span className="licao">
                                {aula.nome}
                                {aula.modulo_Aulas_Utilizadores && aula.modulo_Aulas_Utilizadores.marcador && (
                                    <span className="marcador" style={{ marginLeft: "10px" }}>
                                        <i className="fas fa-bookmark" />
                                    </span>
                                )}
                            </span>
                        </Link>
                    );
                } //AUDIO
                else if (tipoId === 3 || tipoId === 12) {
                    //HTML
                    return (
                        <Link
                            to={`${inicioUrl}${aula.tipo_Recurso.url}`}
                            onClick={() => this.onClink(aula.id)}
                            //disabled={this.validarDisponibilidade()}
                        >
                            <span className="start" title={aula.tipo_Recurso.nome} style={{ width: 30, height: 30 }}>
                                <img src={iconHtml} style={{ width: "100%", objectFit: "contain", borderRadius: "50%" }} />
                            </span>
                            <span className="licao">
                                {aula.nome}
                                {aula.modulo_Aulas_Utilizadores && aula.modulo_Aulas_Utilizadores.marcador && (
                                    <span className="marcador" style={{ marginLeft: "10px" }}>
                                        <i className="fas fa-bookmark" />
                                    </span>
                                )}
                            </span>
                        </Link>
                    );
                } //HTML
                else if (tipoId === 4) {
                    //PDF
                    return (
                        <Link
                            to={`${inicioUrl}${aula.tipo_Recurso.url}`}
                            onClick={() => this.onClink(aula.id)}
                            //disabled={this.validarDisponibilidade()}
                        >
                            <span className="start" title={aula.tipo_Recurso.nome} style={{ width: 30, height: 30 }}>
                                <img src={iconPdf} style={{ width: "100%", objectFit: "contain", borderRadius: "50%" }} />
                            </span>
                            <span className="licao">
                                {aula.nome}
                                {aula.modulo_Aulas_Utilizadores && aula.modulo_Aulas_Utilizadores.marcador && (
                                    <span className="marcador" style={{ marginLeft: "10px" }}>
                                        <i className="fas fa-bookmark" />
                                    </span>
                                )}
                            </span>
                        </Link>
                    );
                } //PDF
                else if (tipoId === 7) {
                    //DOWNLOAD
                    return (
                        <Link
                            to={`${inicioUrl}${aula.tipo_Recurso.url}`}
                            onClick={() => this.onClink(aula.id)}
                            //disabled={this.validarDisponibilidade()}
                        >
                            <span className="start" title={aula.tipo_Recurso.nome} style={{ width: 30, height: 30 }}>
                                <img src={iconDownload} style={{ width: "100%", objectFit: "contain", borderRadius: "50%" }} />
                            </span>
                            <span className="licao">
                                {aula.nome}
                                {aula.modulo_Aulas_Utilizadores && aula.modulo_Aulas_Utilizadores.marcador && (
                                    <span className="marcador" style={{ marginLeft: "10px" }}>
                                        <i className="fas fa-bookmark" />
                                    </span>
                                )}
                            </span>
                        </Link>
                    );
                } //DOWNLOAD
                else if (tipoId === 9) {
                    //LINK
                    return (
                        <Link
                            to={`${inicioUrl}${aula.tipo_Recurso.url}`}
                            onClick={() => this.onClink(aula.id)}
                            //disabled={this.validarDisponibilidade()}
                        >
                            <span className="start" title={aula.tipo_Recurso.nome} style={{ width: 30, height: 30 }}>
                                <img src={iconLink} style={{ width: "100%", objectFit: "contain", borderRadius: "50%" }} />
                            </span>
                            <span className="licao">
                                {aula.nome}
                                {aula.modulo_Aulas_Utilizadores && aula.modulo_Aulas_Utilizadores.marcador && (
                                    <span className="marcador" style={{ marginLeft: "10px" }}>
                                        <i className="fas fa-bookmark" />
                                    </span>
                                )}
                            </span>
                        </Link>
                    );
                } //LINK
                else if (tipoId === 10) {
                    //SUMÁRIO
                    return (
                        <Link
                            to={`${inicioUrl}${aula.tipo_Recurso.url}`}
                            onClick={() => this.onClink(aula.id)}
                            //disabled={this.validarDisponibilidade()}
                        >
                            <span className="start" title={aula.tipo_Recurso.nome} style={{ width: 30, height: 30 }}>
                                <img src={iconSumario} style={{ width: "100%", objectFit: "contain", borderRadius: "50%" }} />
                            </span>
                            <span className="licao">
                                {aula.nome}
                                {aula.modulo_Aulas_Utilizadores && aula.modulo_Aulas_Utilizadores.marcador && (
                                    <span className="marcador" style={{ marginLeft: "10px" }}>
                                        <i className="fas fa-bookmark" />
                                    </span>
                                )}
                                {aula.dt_inicio && (
                                    <span className="data-hora">
                                        <strong>
                                            {moment(aula.dt_inicio).format("DD/MM/YYYY")}
                                            {aula.hora && <> - {aula.hora}</>}
                                        </strong>
                                    </span>
                                )}
                            </span>
                        </Link>
                    );
                } //SUMÁRIO
                else {
                    //PRESENCIAL
                    return (
                        <Link to={`${inicioUrl}${aula.tipo_Recurso.url}`} onClick={() => this.onClink(aula.id)}>
                            <span className="start" title={aula.tipo_Recurso.nome} style={{ width: 30, height: 30 }}>
                                <img src={iconSessaoPresencial} style={{ width: "100%", objectFit: "contain", borderRadius: "50%" }} />
                            </span>
                            <span className="licao">
                                {aula.nome}
                                {aula.modulo_Aulas_Utilizadores && aula.modulo_Aulas_Utilizadores.marcador && (
                                    <span className="marcador" style={{ marginLeft: "10px" }}>
                                        <i className="fas fa-bookmark" />
                                    </span>
                                )}
                                {aula.dt_inicio && (
                                    <span className="data-hora">
                                        <strong>
                                            {moment(aula.dt_inicio).format("DD/MM/YYYY")}
                                            {aula.hora && <> - {aula.hora}</>}
                                        </strong>
                                    </span>
                                )}
                            </span>
                        </Link>
                    );
                } //PRESENCIAL
            } else {
                var icon = "";

                if (tipoId === 1) icon = <img src={iconVideo} style={{ width: "100%", objectFit: "contain", borderRadius: "50%" }} />;
                else if (tipoId === 2) icon = <img src={iconAudio} style={{ width: "100%", objectFit: "contain", borderRadius: "50%" }} />;
                else if (tipoId === 3) icon = <img src={iconHtml} style={{ width: "100%", objectFit: "contain", borderRadius: "50%" }} />;
                else if (tipoId === 4) icon = <img src={iconPdf} style={{ width: "100%", objectFit: "contain", borderRadius: "50%" }} />;
                else if (tipoId === 7)
                    icon = <img src={iconDownload} style={{ width: "100%", objectFit: "contain", borderRadius: "50%" }} />;
                else if (tipoId === 9) icon = <img src={iconLink} style={{ width: "100%", objectFit: "contain", borderRadius: "50%" }} />;
                else if (tipoId === 10)
                    icon = <img src={iconSumario} style={{ width: "100%", objectFit: "contain", borderRadius: "50%" }} />;
                else if (tipoId === 11)
                    icon = <img src={iconSessaoPresencial} style={{ width: "100%", objectFit: "contain", borderRadius: "50%" }} />;

                return (
                    <Link to="#" style={{ cursor: "default" }}>
                        <span className="start" title={aula.tipo_Recurso.nome} style={{ width: 30, height: 30 }}>
                            {icon}
                        </span>
                        <span className="licao">{aula.nome}</span>
                    </Link>
                );
            }
        };

        return (
            <>
                <Collapse
                    defaultActiveKey={this.props.disabled ? [] : [localStorage.getItem("modulo_aberto")]}
                    bordered={false}
                    onChange={this.onChangeCollapse}
                    key={this.props.index}
                >
                    <Panel
                        header={tituloModulo}
                        key={this.props.index}
                        className="modulo"
                        disabled={this.props.modulo.modulo_Aula.length === 0}
                    >
                        {this.props.modulo.pagina_unica ? (
                            !this.props.disabled &&
                            this.state.collapsed.find(x => x === this.props.index + "") && (
                                <div
                                    ref={this.elementFullScreen}
                                    style={this.state.fullscreen ? { padding: 40, background: "white" } : { background: "white" }}
                                >
                                    <Icon
                                        type={this.state.fullscreen ? "fullscreen-exit" : "fullscreen"}
                                        onClick={this.onClickFullscreenElement}
                                        className="btn-fullscreen"
                                        style={{ padding: "0 0 20px 0" }}
                                    />
                                    <div dangerouslySetInnerHTML={{ __html: this.props.modulo.modulo_Aula[0].recurso }}></div>
                                </div>
                            )
                        ) : (
                            <ul>
                                {this.props.modulo.modulo_Aula.map((aula, index) => (
                                    <li key={index}>
                                        <div className="nivel1">
                                            {montaAula(this.props.modulo.id, aula, this.props.modulo.estado === "ATIVO")}
                                        </div>
                                        <div className="nivel2">
                                            <ul>
                                                {aula.modulo_Aula_lvl2.map((aulalvl2, index2) => (
                                                    <li key={index2}>
                                                        {montaAulaLvl2(
                                                            this.props.modulo.id,
                                                            aulalvl2,
                                                            index2,
                                                            this.props.modulo.estado === "ATIVO"
                                                        )}
                                                    </li>
                                                ))}
                                            </ul>
                                        </div>
                                    </li>
                                ))}
                            </ul>
                        )}
                    </Panel>
                </Collapse>
            </>
        );
    }
}

export default Modulo;
